export default {
	//COMMENT AUTOMATION
	newPostCommentsMap(state) {
		var map = {}
		for (const comment of state.CommentAutomations) {
			map[comment.id] = comment
		}
		return map
	},
}